import { render, staticRenderFns } from "./BulkImport_Contact.vue?vue&type=template&id=89c9c754&scoped=true&"
import script from "./BulkImport_Contact.vue?vue&type=script&lang=ts&"
export * from "./BulkImport_Contact.vue?vue&type=script&lang=ts&"
import style0 from "./BulkImport_Contact.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BulkImport_Contact.vue?vue&type=style&index=1&id=89c9c754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c9c754",
  null
  
)

export default component.exports